import { createApiQueryHook, type IApiQueryFunction, mapOrder, mapPagination } from "../../utils/api";
import { mapRelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import type { IFollowUpList } from "../types";
import type { IFollowUpListQueryParameters } from "./followUpListQuery";
import { PeriodParam } from "../../types/PeriodParam";

export type IFollowUpWithSelfEvaluationListQueryParameters = IFollowUpListQueryParameters;

export type IFollowUpWithSelfEvaluationListQueryResult = IFollowUpList;

const mapFilters = (filters: IFollowUpWithSelfEvaluationListQueryParameters["filters"]) => {
    const { learner, createdBy, title, skill, periodStart, periodEnd, availableSkill, intervalStart, intervalEnd } =
        filters ?? {};

    return {
        "learner.uuid": mapRelationalFilter(learner),
        "createdBy.uuid": mapRelationalFilter(createdBy),
        "briefs.skillLevels.skill.uuid": mapRelationalFilter(skill),
        "availableSkill.uuid": mapRelationalFilter(availableSkill),
        [`periodStart[${periodStart?.param ?? PeriodParam.BEFORE}]`]: periodStart?.date,
        [`periodEnd[${periodEnd?.param ?? PeriodParam.BEFORE}]`]: periodEnd?.date,
        title,
        intervalStart,
        intervalEnd,
    };
};

export const followUpWithSelfEvaluationQuery: IApiQueryFunction<IFollowUpWithSelfEvaluationListQueryParameters> = ({
    pagination,
    filters,
    order,
}) => ({
    method: "GET",
    url: `/follow_ups/with_self_evaluation${serialize(
        {
            ...mapFilters(filters),
            ...mapPagination(pagination),
            ...mapOrder(order),
        },
        true,
    )}`,
});

export const useFollowUpWithSelfEvaluationQuery = createApiQueryHook<
    IFollowUpWithSelfEvaluationListQueryParameters,
    IFollowUpWithSelfEvaluationListQueryResult
>(followUpWithSelfEvaluationQuery);
